module.exports = __webpack_public_path__ + "static/img/10.46b0a37.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/10.png
// module id = ZRnE
// module chunks = 0